
interface SpeciesIdCardProps {
  item: [string, string];
  kingdom: string;
  occStatus: string;
  wanted: boolean;
  allBarcodes: number;
  ariseBarcodes: number;
  otherBarcodes: number;
  collected: number;
  locality: string;
}
export default function SpeciesIdCard({
  item,
  kingdom,
  occStatus,
  wanted,
  allBarcodes,
  ariseBarcodes,
  otherBarcodes,
  collected,
  locality,
}: SpeciesIdCardProps) {
  return (
    <div className="species-idCard">
      <h2>{item[1]}</h2>

      {wanted ? (
        kingdom === "Plantae" &&
        ["1a", "1b", "2a", "2b"].includes(occStatus) ? (
          <div className="speciesStatus wanted-priority mb-4">Priority</div>
        ) : (
          <div className="speciesStatus wanted mb-4">Wanted</div>
        )
      ) : (
        <div>
          <div className="speciesStatus unwanted">Unwanted</div>
          <p className="d-inline-flex mt-3 mb-5">
            <span className="btn-icon infoBtn red">i</span> We already received enough specimens of this species.
            If you already collected a specimen, you can still send it to ARISE, but please do not collect more of it.
          </p>
        </div>
      )}

      <p className="barcodes">Total barcodes <span className="underline"></span> {allBarcodes}</p>
      <p className="barcodes">Arise barcodes <span className="underline"></span> {ariseBarcodes}</p>
      <p className="barcodes">Other barcodes <span className="underline"></span> {otherBarcodes}</p>
      <p className="barcodes">Collected <span className="underline"></span> {collected}</p>

      {locality && (
        <p><span className="title">Locality:</span> {locality}</p>
      )}

      <p className="barcodes">Occurrence status <span className="underline"></span> {occStatus}</p>
    </div>
  );
}